<template>
  <BaseList listSubtitulo="Lista de usuários" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template v-if="isSuperUser" #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="data.id === currentUserId"
            :title="data.id === currentUserId ? 'Ação não permitida para o próprio usuário.' : ''"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('alterarDados', data.id)">
              <i class="fa fa-warning"></i> ALTERAR DADOS
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('alterarSenha', data.id)">
              <i class="fa fa-key"></i> ALTERAR SENHA
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('editarPerfil', data.id)">
              <i class="fa fa-user"></i> EDITAR PERFIL
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.id, data.username)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarUser
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastrarUsuario'"
      :is-admin-view="isAdminView"
      @fechar="fecharModal"
      @atualizarListaUsuarios="atualizarListaUser"
  />
  <EditarUser
      v-if="modalAtivo === 'alterarDados'"
      :idModal="'alterarDadosUser'"
      :is-admin-view="isAdminView"
      @fechar="fecharModal"
      @atualizarDados="atualizaDadosUser"
      :usuarioId="Number(usuarioSelect)"
  />
  <AlterarSenha
      v-if="modalAtivo === 'alterarSenha'"
      :idModal="'alterarSenhaUser'"
      @fechar="fecharModal"
      :usuarioId="Number(usuarioSelect)"
  />
  <EditarPerfilUser
      v-if="modalAtivo === 'editarPerfil'"
      :idModal="'editarPerfilUser'"
      @fechar="fecharModal"
      @atualizarPerfilUsuario="atualizaDadosPerfilUser"
      :usuarioId="Number(usuarioSelect)"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarUser from "./CadastrarUser.vue";
import EditarUser from "./EditarUser.vue";
import AlterarSenha from "./AlterarSenha.vue";
import EditarPerfilUser from "./EditarPerfilUser.vue";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaUsers",
  components: {
    BaseList,
    CadastrarUser,
    EditarUser,
    AlterarSenha,
    EditarPerfilUser,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      usuarioSelect: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      isSuperUser: localStorage.getItem('admin_isSuperUser'),
      currentUserId: Number(localStorage.getItem('admin_userID')),
    };
  },
  computed: {
    isAdminView() {
      return this.$route.name === 'admin_usuarios';
    },
    columns() {
      return [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'full_name', header: 'NOME',},
        {field: 'email', header: 'E-MAIL',},
        {
          field: 'empresa_nome',
          header: 'EMPRESA',
          visible: this.isAdminView,
        },
        {
          field: 'last_login',
          header: 'ÚLTIMO LOGIN',
          align: 'text-center',
          body: row => {
            const className = row.last_login === row.data_atual ? 'text-success font-bold' : ''
            return `<span class="${className}">${row.last_login}</span>`
          }
        },
        {
          field: 'is_active',
          header: 'STATUS',
          align: 'text-center',
          body: row => row.is_active ? '<span class="text-success font-bold">ATIVO</span>' : '<span class="text-danger font-bold">INATIVO</span>'
        },
        {
          field: 'is_staff',
          header: 'EQUIPE',
          align: 'text-center',
          visible: this.isAdminView,
          body: row => `<i class="${row.is_staff ? "fa fa-check-circle text-success" : "fa fa-circle-thin"}"></i>`
        },
        {
          field: 'is_superuser',
          header: 'SUPER USUÁRIO',
          align: 'text-center',
          visible: this.isAdminView,
          body: row => `<i class="${row.is_superuser ? "fa fa-check-circle text-success" : "fa fa-circle-thin"}"></i>`
        },
      ];
    }
  },

  methods: {
    atualizarListaUser(novoUser) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDadosUser(UserAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === UserAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = UserAtualizado;
      }
    },
    atualizaDadosPerfilUser(perfilAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === perfilAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = perfilAtualizado;
      }
    },
    abrirModal(tipo, id = null) {
      this.modalAtivo = tipo;
      if (id) {
        this.usuarioSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(usuarioId, usuarioNome) {
      const url = this.isAdminView 
        ? apiUrl.usuarios.adminRetrieveUpdateDestroy(usuarioId)
        : apiUrl.usuarios.retrieveUpdateDestroy(usuarioId);
      alertDelete(usuarioId, url, 'Você deseja deletar o registro?', `ID: ${usuarioId} | ${usuarioNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const url = this.isAdminView 
        ? apiUrl.usuarios.adminCreateList 
        : apiUrl.usuarios.createList;

      const resultado = await apiRequest("GET", url, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
